import React from 'react';

import { Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

export default function ContextDetail({ label, value }: Props) {
  return (
    <Typography variant="body2" color="text.secondary">
      <strong>{label}:</strong> {value}
    </Typography>
  );
}
